import { SortingRule } from 'react-table';
import { atom, selector } from 'recoil';
import { addDays } from 'date-fns';

import { AuditRequest, FilterOption, PaginationInfo } from '../../types';
import { GetAuditRequestsRequest } from '../../api';

export const trafficMonitorFiltersState = atom<FilterOption[]>({
  key: 'trafficMonitorFilters',
  default: [],
});

export const trafficMonitorStartDateState = atom<Date>({
  key: 'trafficMonitorStartDate',
  default: addDays(new Date(), -7),
});

export const trafficMonitorEndDateState = atom<Date>({
  key: 'trafficMonitorEndDate',
  default: new Date(),
});

export const trafficMonitorOrderByColumnState = atom<string | undefined>({
  key: 'trafficMonitorOrderByColumn',
  default: undefined,
});

export const trafficMonitorOrderByDescendingState = atom<boolean>({
  key: 'trafficMonitorOrderByDescending',
  default: false,
});

export const trafficMonitorPageSizeState = atom<number>({
  key: 'trafficMonitorPageSize',
  default: 10,
});

export const trafficMonitorPageNumberState = atom<number>({
  key: 'trafficMonitorPageNumber',
  default: 1,
});

export const trafficMonitorDirectionState = atom<string>({
  key: 'trafficMonitorDirectionState',
  default: 'Inbound',
});

export const trafficMonitorTextSearchState = atom<string>({
  key: 'trafficMonitorTextSearchState',
  default: '',
});

export const trafficMonitorSortByState = selector<SortingRule<AuditRequest>[]>({
  key: 'trafficMonitorSortBy',
  get: ({ get }) => {
    const orderByColumn = get(trafficMonitorOrderByColumnState);
    const orderByDescending = get(trafficMonitorOrderByDescendingState);
    return orderByColumn ? [{ id: orderByColumn, desc: orderByDescending }] : [];
  },
});

export const trafficMonitorDataState = atom<AuditRequest[] | undefined>({
  key: 'trafficMonitorDataState',
  default: undefined,
});

export const trafficMonitorPaginationState = atom<PaginationInfo | undefined>({
  key: 'trafficMonitorPaginationState',
  default: undefined,
});

export const trafficMonitorRequestState = selector<GetAuditRequestsRequest>({
  key: 'auditRequestsRequest',
  get: ({ get }) => {
    const sortByDesc = get(trafficMonitorOrderByDescendingState);
    const sortByColumn = get(trafficMonitorOrderByColumnState);

    const request = {
      keyword: get(trafficMonitorTextSearchState),
      startDate: get(trafficMonitorStartDateState)?.toISOString() ?? '',
      endDate: get(trafficMonitorEndDateState).toISOString() ?? '',
      apiCall:
        get(trafficMonitorFiltersState).filter((x) => x.name === 'apiCall')[0]
          ?.selectedItems[0]?.value ?? '',
      status:
        get(trafficMonitorFiltersState).filter((x) => x.name === 'status')[0]?.selectedItems[0]
          ?.value ?? '',
      httpCode:
        get(trafficMonitorFiltersState).filter((x) => x.name === 'httpCode')[0]
          ?.selectedItems[0]?.value ?? '',
      pageSize: get(trafficMonitorPageSizeState),
      pageNumber: get(trafficMonitorPageNumberState),
      ...(sortByColumn && {
        sortByValue: sortByColumn,
        sortBy: sortByDesc ? 'Descending' : 'Ascending',
      }),
    } as unknown as GetAuditRequestsRequest;

    get(trafficMonitorFiltersState).forEach((filter) => {
      if (!filter.isSearchText) {
        request[filter.name] = filter.selectedItems.map((selected) => selected.value);
      }
    });

    return request;
  },
});
